import styled from "styled-components";

export const LabelInlineIconStyled = styled.span`
  .theme_standard_label_inline_icon {
      display: inline-flex;
      align-items: center;
      gap: ${({ theme }) => theme.FONT.SIZE.S7};
    .icon_wrap {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;
    }

    .label_text {
      white-space: nowrap;
    }
  }
    .theme_title {
      display: inline-flex;
      align-items: center;
      gap: 12px;
      .icon_wrap {
        display: inline-flex;
        align-items: center;
        flex-shrink: 0;
      }
      .label_text {
        font-size: ${({ theme }) => theme.FONT.SIZE.S20};
        font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        white-space: nowrap;
      }
    }
`;
